/**
 * api接口的统一出口
 */
// 测试接口
import strageList from '@/api/module/strageList';
import answerList from '@/api/module/answerList';

// 其他模块的接口……

// 导出接口
export default {
  strageList,
  answerList
 
};
